import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { login as loginService, logout as logoutService } from '../services/auth';

// Define the user type
interface User {
  token: string;
}

export const useAuth = () => {
  // Specify that `user` can be either `User` or `null`
  const [user, setUser] = useState<User | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      setUser({ token }); // Now TypeScript understands this
    }
  }, []);

  const login = async (credentials: { username: string; password: string }) => {
    try {
      const data = await loginService(credentials);
      localStorage.setItem('token', data.token);
      setUser({ token: data.token }); // This is now valid
      navigate('/');
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  const logout = () => {
    logoutService();
    setUser(null); // Reset the user state to `null` on logout
    navigate('/login');
  };

  return { user, login, logout };
};
